"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ASPECT_RATIO_OPTIONS = void 0;
var _aspectRatio = require("./aspectRatio");
var ASPECT_RATIO_OPTIONS = [{
  label: 'High Definition 16:9',
  resolution: '16:9',
  value: _aspectRatio.ASPECT_RATIO.WIDE,
  prefix: 'monitor'
}, {
  label: 'Standard Definition 4:3',
  resolution: '4:3',
  value: _aspectRatio.ASPECT_RATIO.STANDARD,
  prefix: 'standard'
}, {
  label: 'Portrait 9:16',
  resolution: '9:16',
  value: _aspectRatio.ASPECT_RATIO.INSTA,
  prefix: 'portrait'
}, {
  label: 'Square 1:1',
  resolution: '1:1',
  value: _aspectRatio.ASPECT_RATIO.SQUARE,
  prefix: 'square'
}];
exports.ASPECT_RATIO_OPTIONS = ASPECT_RATIO_OPTIONS;